import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Collapse, Button, CardBody, CardHeader, Card } from 'reactstrap';

class ApiDefinitionRow extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <li className="api-definition-row">
        <div className="span-12">
          <div className="row">
            <div className="col-4 api-definition-label">
              {this.props.t(`objectLabel.${this.props.item.name}-label`)}<br />
              <small><span className="badge badge-pill badge-dark">{this.props.item.dataType}</span></small>
            </div>
            <div className="col-lg api-definition-description">
              {this.props.t(`objectDescription.${this.props.item.name}-description`)}
            </div>
          </div>
        </div>
        { this.props.item.properties && 
          <Card className="mt-2">
            <CardHeader>
              <button onClick={this.toggle} className="toggle-sub-properties">{this.props.t('common:toggle-attributes')}</button>
            </CardHeader>
            <Collapse isOpen={this.state.collapse}>
              <table className="table table-striped overflow-scroll">
                <tbody>
                { this.props.item.properties.map((item, index) => (
                  <tr key={index}>
                    <th className="api-definition-label">{this.props.t(`objectLabel.${this.props.item.name}-attributes.${item.name}-label`)}<br /><span className="badge badge-pill badge-dark">{item.dataType}</span></th>
                    <td>{this.props.t(`objectDescription.${this.props.item.name}-attributes.${item.name}-description`)}</td>
                  </tr>
                ) )}
                </tbody>
              </table>
            </Collapse>
          </Card>
        }
      </li>
    );
  }

};

export default translate((props) => props.namespaces)(ApiDefinitionRow);



// WEBPACK FOOTER //
// ./src/components/ApiDefinitionRow.jsx